import React from "react";
import { useNavigate } from "react-router-dom";

const ErrorPage = ({ code = 404, message, description }) => {
  const navigate = useNavigate();

  const defaultMessages = {
    404: {
      message: "Page Not Found",
      description:
        "Sorry, we couldn't find the page you were looking for. It might have been moved or deleted.",
    },
    500: {
      message: "Internal Server Error",
      description: "Oops! Something went wrong on our end. Please try again later.",
    },
    403: {
      message: "Access Denied",
      description: "You don't have permission to view this page.",
    },
    401: {
      message: "Unauthorized",
      description: "Please login to access this page.",
    },
  };

  const errorData = {
    message: message || (defaultMessages[code]?.message) || "Error",
    description: description || (defaultMessages[code]?.description) || "Something went wrong.",
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.code}>{code}</h1>
        <h2 style={styles.message}>{errorData.message}</h2>
        <p style={styles.description}>{errorData.description}</p>
        <button style={styles.button} onClick={() => navigate("/")}>
          Go Back Home
        </button>
      </div>
      <div style={styles.bgCircle}></div>
      <div style={{ ...styles.bgCircle, ...styles.bgCircle2 }}></div>
    </div>
  );
};

const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #f6d365 0%, #fda085 100%)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  card: {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    padding: "50px 40px",
    borderRadius: "20px",
    textAlign: "center",
    zIndex: 2,
    boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
    animation: "fadeIn 0.8s ease-out",
  },
  code: {
    fontSize: "8rem",
    color: "#ff6b6b",
    margin: 0,
  },
  message: {
    fontSize: "2rem",
    margin: "20px 0",
    color: "#333",
  },
  description: {
    fontSize: "1.1rem",
    marginBottom: "30px",
    color: "#666",
    maxWidth: "400px",
    margin: "0 auto 30px",
  },
  button: {
    padding: "12px 30px",
    borderRadius: "50px",
    border: "none",
    backgroundColor: "#6c63ff",
    color: "#fff",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  bgCircle: {
    position: "absolute",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.15)",
    top: "-50px",
    right: "-50px",
    zIndex: 1,
    animation: "float 6s ease-in-out infinite alternate",
  },
  bgCircle2: {
    width: "200px",
    height: "200px",
    bottom: "-30px",
    left: "-30px",
    top: "auto",
    right: "auto",
    animationDuration: "8s",
  },
  "@keyframes float": {
    "0%": { transform: "translateY(0px)" },
    "100%": { transform: "translateY(20px)" },
  },
};

export default ErrorPage;
/* ================================ */